import React from 'react'

import Select from 'react-select'
import axios from 'axios'
import {getToken, getSettingsOptionValue} from '../../../storage'
import {calculatePurchasePrice} from '../../../utils/calculator'
import {API_BASE_URL} from '../../../constants'
import {ItemExtended} from '../../commons/functions'
import {AddItemModal} from '../../modal/modal'


export default class NameElement extends React.Component {

  constructor(props){
    super(props)
    this.handleChange=this.handleChange.bind(this)
    this.createItemPromt = this.createItemPromt.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.state= {showItemCreate:false}
    this.handleItemModal = this.handleItemModal.bind(this)
  }
  handleItemModal() {
    this.setState({
      showItemCreate:false
    })
  }

  createItemPromt(input){
    return "Create new item ?"
  }

  handleChange(item){

    if(item !== null && typeof item.className !== "undefined" ) {
        this.setState({
          showItemCreate:true
        })
    }
    else if(item !== null) {

      const saleitem = {
        original: item,
        serial: item.serial,
        item: item.id, // saleitem is pointed to item
        name: item.name,
        description:item.description,
        hsn: item.hsn,
        quantity:1,
        tableIndex: this.props.item.tableIndex,
        mrp: parseFloat(item.mrp),
        discounts: item.discounts,
        selling_basic_rate: parseFloat(item.selling_basic_rate),
        purchase_basic_rate: parseFloat(item.closing_purchase_basic_rate),
        selling_rate: parseFloat(item.selling_rate),
        price: (typeof this.props.is_composition !== "undefined" && this.props.is_composition ?parseFloat(item.selling_rate): parseFloat(item.selling_basic_rate)),
        gst: item.gst,
        cgst_amount: parseFloat(item.cgst_amount), sgst_amount: parseFloat(item.sgst_amount), igst_amount: parseFloat(item.igst_amount),
        total: parseFloat(item.selling_rate),
        discount_value: 0,
        cess_percentage: parseFloat(item.cess_percentage),
        specific_cess_amount: parseFloat(item.specific_cess_amount),
        specific_cess: parseFloat(item.specific_cess_amount)

       }

       let invoice_auto_fill_price = getSettingsOptionValue('invoice_auto_fill_price') || 'default'
       if(invoice_auto_fill_price === "cpr"){
        saleitem['selling_basic_rate'] = parseFloat(item.closing_purchase_basic_rate)
        saleitem['selling_rate'] = parseFloat(calculatePurchasePrice(item.closing_purchase_basic_rate, item.gst.igst))
        saleitem['total'] = parseFloat(calculatePurchasePrice(item.closing_purchase_basic_rate, item.gst.igst))
       }

       this.props.onAddCallback(saleitem)
       this.setState({showItemCreate:false})
    }
    else {
      const i = {
        serial:"",
        name: "",
        hsn: "",
        quantity:1,
        tableIndex: this.props.item.tableIndex,
        mrp:0,
        gst:{},
        discount_set: [],
        selling_basic_rate: 0,
        purchase_basic_rate: 0,
        selling_rate:0,
        discount_value:0,
        price: 0,
        tax: 0,
        cgst_amount: 0, sgst_amount: 0, igst_amount: 0,
        total: 0
       }
       this.props.onAddCallback(i)
       this.setState({showItemCreate:false})
    }
  }

  getItems (input) {
    if (!input) {
      return Promise.resolve({ options: [] });
    }
    return   axios({
        url: '/list_items/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.items}
      }).catch((err)=> {
        return Promise.resolve({ options: [] });
      })
}

renderOption(option) {
  return <ItemExtended option={option} requireRates={this.props.requireRates} requireBrand={this.props.requireBrand} />
}



  render() {


    let modal = <AddItemModal show={this.state.showItemCreate} handleModalToggle={this.handleItemModal} onAddCallback={this.handleChange} />


    let inputValue = this.props.item

    let show_stock = this.props.show_stock
    if(typeof show_stock !== "undefined" && show_stock === false) {
      return (<div>
          {modal}
      <Select.AsyncCreatable name="name" className="" value={inputValue} promptTextCreator={this.createItemPromt}
        valueKey="id" labelKey="name" loadOptions={this.getItems} onChange={this.handleChange} />
      </div>)
    }

    return (<div>
        {modal}
    <Select.AsyncCreatable name="name" className="" value={inputValue} promptTextCreator={this.createItemPromt}
      optionRenderer={this.renderOption} 
      valueKey="id" labelKey="name" loadOptions={this.getItems} onChange={this.handleChange} autoFocus={this.props.item.namefocus} />
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/nameelement.js